module.exports = __webpack_public_path__ + "442f59e8053d774493001508d792d809.svg";